module.exports = __webpack_public_path__ + "img/layer2.3981b78f.png";